import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderuiComponent } from './header-ui.component';



@NgModule({
  declarations: [HeaderuiComponent],
  imports: [
    CommonModule
  ],
  exports:[HeaderuiComponent]
})
export class HeaderuiModule { }
